import { useMemo } from 'react';
import type { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';

function isSourceSupported(source: string | undefined) {
  return source === 'XONE' || source === 'ELIOT';
}
export function useBcsProductKeyAsLabel(bcsProductKey: BcsProductKey | undefined) {
  return useMemo(
    () =>
      isSourceSupported(bcsProductKey?.source?.toUpperCase())
        ? `${bcsProductKey?.source} ${bcsProductKey?.subType}-${bcsProductKey?.code}`
        : undefined,
    [bcsProductKey],
  );
}
